import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'

const { Menu: DropdownMenu } = Dropdown

function firstNonUndefined(values) {
  return values.find(val => val !== undefined)
}

export default function Menu({ data }) {
  return (
    <DropdownMenu>
      {data.map(
        ({ id, key, name, title, value, text, disabled = false }, index) => (
          <DropdownMenu.Item
            key={id || key || index}
            itemKey={firstNonUndefined([value, id, key, name])}
            disabled={disabled}
          >
            {name || title || text || key}
          </DropdownMenu.Item>
        )
      )}
    </DropdownMenu>
  )
}
